<ui-tab-group class="hidden sm:block">
  <a
    routerLink="./general"
    routerLinkActive
    #general="routerLinkActive"
    [attr.aria-current]="general.isActive"
  >
    <ui-tab [active]="general.isActive">
      <h2 class="flex">
        <ng-icon name="heroInformationCircle" size="20" class="!block mr-2" />
        {{ 'cockpit.parseRequests.detailsPage.navGeneral' | transloco }}
      </h2>
    </ui-tab>
  </a>
  <a
    routerLink="./admin"
    routerLinkActive
    #admin="routerLinkActive"
    [attr.aria-current]="admin.isActive"
    *hasRole="'USER_ADMIN'"
  >
    <ui-tab [active]="admin.isActive">
      <h2 class="flex text-admin dark:text-admin-darkmode">
        <ng-icon name="heroCodeBracketSquare" size="20" class="!block mr-2" />
        {{ 'cockpit.parseRequests.detailsPage.navAdminEdit' | transloco }}
      </h2>
    </ui-tab>
  </a>
</ui-tab-group>
<div class="sm:hidden">
  <ui-select (selectChange)="onSelectChange($event)">
    <option
      routerLink="./general"
      routerLinkActive
      #generalMobile="routerLinkActive"
      value="./general"
      [selected]="generalMobile.isActive"
    >
      {{ 'cockpit.parseRequests.detailsPage.navGeneral' | transloco }}
    </option>
    <option
      routerLink="./admin"
      routerLinkActive
      #adminMobile="routerLinkActive"
      value="./admin"
      [selected]="adminMobile.isActive"
      *hasRole="'USER_ADMIN'"
    >
      {{ 'cockpit.parseRequests.detailsPage.navAdminEdit' | transloco }}
    </option>
  </ui-select>
</div>
